import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../common/CmnContext';


export function SaleListDetailMovieThumb(props: any) {

  const sale = props.sale;
  const available = props.available;
  const dispIndex = props.dispIndex;
  const movieList = props.movieList;
  const saleImageList = props.saleImageList;

  const isPc = useContext(cmnContext).isPc;


  return (
    <div style={{
      width: '100%',
      backgroundColor: 'black',
      padding: '5px 0',
    }}>
      {available ?
        <div style={{
          width: '100%',
          aspectRatio: '16/9',
        }}>
          {/* 動画 */}
          {movieList[dispIndex] &&
            <iframe
              width="100%"
              height="100%"
              src={movieList[dispIndex]}
              allow="autoplay; encrypted-media"
              allowFullScreen
            >
              <param name="allowFullScreen" value="true"/>
            </iframe>
          }
        </div>
      :
        <>
          {/* サムネイル */}
          {saleImageList[dispIndex] &&
            <img
              src={`/images/sale/${saleImageList[dispIndex]}`}
              style={{
                display: 'block',
                maxWidth: '100%',
                height: isPc? '50vh' : '30vh',
                objectFit: 'contain',
                objectPosition: 'center',
                margin: '0px auto',
              }}
              alt={sale.name}
            />
          }
        </>
      }
    </div>
  );
}